// extracted by mini-css-extract-plugin
export var body = "j_d";
export var layout = "j_L";
export var menu = "j_M";